import { render, staticRenderFns } from "./ClassicInfinityDimensionsTab.vue?vue&type=template&id=666764c9&scoped=true&"
import script from "./ClassicInfinityDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ClassicInfinityDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassicInfinityDimensionsTab.vue?vue&type=style&index=0&id=666764c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666764c9",
  null
  
)

export default component.exports